<template>
	<div>
        <buttonlist @help="help" ref="SetBtn"></buttonlist>
        <el-card class="box-card">
            <div style="display: flex;background: white">
                <div style="width: 50%;text-align: left;display: flex">
                    <el-button type="primary" size="mini" @click="deleteAll">{{$t('getapi[3886]')}}</el-button>
                   
                    <el-upload
                            class="upload-demo"
                            ref="upload"
                            :action="uploadurl"
                            :on-preview="handlePreview"
                            :on-remove="handleRemove"
                            :on-change="handleChange"
                            :on-success="handleSuccess"
                            :on-error="handleError"
                            :file-list="fileList"
                            :limit="1"
							accept=".xlsx"
                            style="margin-left: 8px"
                    >
                        <el-button slot="trigger" size="mini" type="primary" :disabled="!btn.Import">{{$t('getapi[372]')}}</el-button>
                    </el-upload>
                </div>
                <div style="width: 50%;text-align: right">
                    <el-button type="primary" size="mini" @click="update">{{$t('getapi[370]')}}</el-button>
                    <!--<el-button type="primary" size="mini">关闭</el-button>-->
                </div>
            </div>
        </el-card>
                <div id="xpane-0">
				<vxe-table :data="datajson"
				show-overflow
				ref='CloseSoTable'
				size="mini" :loading="loading"  :height="tableHeight" stripe border resizable>
					<vxe-table-column type="checkbox" align="center" width="60"></vxe-table-column>
					<vxe-table-column  show-footer-overflow v-for="item in returnArray" 
					:key="item.Headcn"
					:field="item.Headcn"
					:title="item.Headcn"
					width="140px"
					>
                    
                    
                    </vxe-table-column>
				</vxe-table>
                </div>
				<!-- <el-row>
				<el-col :span="24">
					<div style="text-align: left;line-height: 30px;color: blue;font-size:larger">共选择了:<strong>{{ datajson.length }} </strong>条SO工单</div>
				</el-col>
				</el-row> -->
			

	</div>
</template>

<script>
import Common from '@/components/Common';
import Array from '@/components/Array';
import CommonHeader from '@/components/CommonHeader';
export default {
	name:'workhourimport',
    computed: {
        tableHeight(){
            return this.$windowSize.tableHeight-170
        }
    },
	data() {
		return {
            fileList: [],
            returnArray:[],
			itevisible:false,
			tabIndex:'0',
			ids: '',
			showloading: '',
			DbTbNames: '', //表名
			datajson: [],
			datajsonremark: [],
			datajsonliu: [],
			loading: false, // 主表加载状态
            excelURL:'',
			uploadurl: '',
			uploadurlplan:'',
			uploadurlremark: '',
			uploadurlliu: '',
			drolist: [],
			drolistliu: [],
			drosele: 0,
			droseleliu: 0,
			total1: 0,
			btn:{
				//添加
				Add:true,
				//移除
        Remove:false,
        //导入
        Import:true
			},
            scrollTop:0,
		};
	},
	create() {},
	beforeMount() {
		console.log('beforeMount');
		let that = this;
		that.userData = sessionStorage.getItem('userData');
		let token = JSON.parse(that.userData).token;
		that.uploadurl = Common.Url + '/Pro/SO/WorkHourImportUpFile?token=' + token;
		that.uploadurlplan = Common.Url + '/Pro/SO/PlanSoImportUpFile?token=' + token;
		this.btnauthority();
	},
    watch: {
        datajson: function () {
            let that = this
            that.$nextTick(function () {
                that.$processdata.initForm(0)
            })
        },
    },
    activated () {
        let that = this
        setTimeout(() => {
            that.$refs.CloseSoTable.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop = res.target.scrollTop
            },false)
        }, 5000);
        // 路由跳转回来滚动到离开时的位置
        this.$nextTick(()=> {
            setTimeout(() => {
                this.$refs.CloseSoTable.bodyWrapper.scrollTop =this.scrollTop;
            }, 13)
        })
    },
	mounted() {
		console.log('mounted');
		this.authority();
		this.btnauthority();
	},
	methods: {
        help(){
            this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[4025]"),this.$t("getapi[6589]"));
        },
        authority(){
            let that = this
            if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                that.$refs.SetBtn.SetOneBtnEnable('help',true);
            }
            that.$refs.SetBtn.SetButtonEnable('');
        },
		btnauthority() {
			let that = this;			
			//工时
			that.btn.Manhour=false;
			//备注
			that.btn.Notes=false;

			if(that.$limits.authority('plv3', 38, 1) >0){
				//工时
				that.btn.Manhour=true;
				//备注
				that.btn.Notes=true;
			}
			
		},
		// SO选择弹框
		showitems(type) {
			let that =this;
			that.itevisible = true;
			let param = {
				Code: type
			}
			that.tabIndex=type;
            this.$refs.input.clearInput(this.itevisible, param);
		},
		getitem(data){
			let that = this;
			if(that.tabIndex=='0'){
				if(data.length > 0){
					//排重
					for(let i=0;i<data.length;i++){
						let hasAdd=false;
						for(let j=0;j<that.datajson.length;j++){
							if(data[i].so_code==that.datajson[j].so_code){
								hasAdd=true;
								break;
							}
						}
						if(!hasAdd){
							let param=data[i];
							param.State='未校验';
							that.datajson.push(param);
						}
					}
				}
			}else{
				if(data.length > 0){
					//排重
					for(let i=0;i<data.length;i++){
						let hasAdd=false;
						for(let j=0;j<that.datajsonliu.length;j++){
							if(data[i].so_code==that.datajsonliu[j].so_code){
								hasAdd=true;
								break;
							}
						}
						if(!hasAdd){
							let param=data[i];
							//param.old_date = data[i].plan_finish_date;
							param.old_date = that.$limits.getDateType( data[i].plan_finish_date);
							
							delete data[i]["plan_finish_date"];
							//param.State='可修改';
							param.Exec_Flag='0';
							that.datajsonliu.push(param);
						}
					}
				}
			}
		},
		deleteAll(){
			let that = this;
			let selectRecords = this.$refs.CloseSoTable.getCheckboxRecords();
			for(let i=selectRecords.length-1;i>=0;i--){
				let line = this.$refs.CloseSoTable.getRowIndex(selectRecords[i]);
				that.datajson.splice(line, 1);
			}
		},
		deleteAll2(){
			let that = this;
			let selectRecords = this.$refs.PlanSoTable.getCheckboxRecords();
			for(let i=selectRecords.length-1;i>=0;i--){
				let line = this.$refs.PlanSoTable.getRowIndex(selectRecords[i]);
				that.datajsonliu.splice(line, 1);
			}
		},
		//校验1
		check(){
			let that = this;
			if (that.datajson.length<= 0)
            {
                this.$message.warning(that.$t('getapi[4435]'));//"请首先添加要执行关闭的SO工单号。"
                return;
			}
			let count = 0;
			for (let i=0;i<that.datajson.length;i++)
			{
				
				if (that.datajson[i].State == null || (that.datajson[i].State != "未校验" && that.datajson[i].State != "可关闭" && that.datajson[i].State != "不可关闭"))
				{
					count = 1;
					break;
				}
			}
			if (count > 0)
			{
				this.$message.warning(that.$t('getapi[4438]'));//列表中有不存在或非开工状态的SO单，请删除或修改。
				return;
			}
			
			let parm = []
			for( let i=0;i<that.datajson.length;i++){
			parm = [...parm, {
				so_code: that.datajson[i].so_code,
				part_code: that.datajson[i].part_code,
				part_version: that.datajson[i].part_version,
				State: that.datajson[i].State,
				item_code: that.datajson[i].item_code,
				remark: that.datajson[i].remark,
			}]
			}
			that.$http.urlpost('/Pro/SO/CloseSoItemCheck', parm, function(res) {
			if (res.Success == 1) {
				that.datajson = res.DataContent;				
			}
			});
		},
		//执行关闭
		update(){
            let that = this;
            that.loading = true;
            let data ={
			"MultyVer": 0,
			"iTemplate": '',
			"FilePath": that.excelURL,
                LangType: that.$processdata.getLang()
			};
            that.$http.urlpost('/Pro/SO/WorkHourSave', data, function(res) {
            if (res.Success == 1) {
            that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
            }
            that.loading = false;
            });

		},
		update2(){
			let that = this;
			if(that.datajsonliu.length>0){
				that.$http.urlpost('/Pro/SO/PlanSoExecute', that.datajsonliu, function(res) {
				if (res.Success == 1) {
				//that.datajson = res.DataContent;
				that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
				}
				});
			}

		},
		download(){
			let param={
					url:'/Pro/SO/CloseSOTemplate'
				}
				Array.methods.DownLoadTemp(param);
		},
		download2(){
			let param={
					url:'/Pro/SO/ModifySODateTemplate'
				}
				Array.methods.DownLoadTemp(param);
		},
		//删除行
		delline(e) {
			console.log(e);
			let line = e.$rowIndex;
			if (line >= 0) {
				this.datajson.splice(line, 1);
			} else {
				this.$message.error(this.$t('getapi[8710]'));//'移除失败'
			}
		},
		dellines(e) {
			let line = e.$rowIndex;
			if (line >= 0) {
				this.datajsonremark.splice(line, 1);
			} else {
				this.$message.error(this.$t('getapi[8710]'));//'移除失败'
			}
		},
		dellineliu(e) {
			let line = e.$rowIndex;
			if (line >= 0) {
				this.datajsonliu.splice(line, 1);
			} else {
				this.$message.error(this.$t('getapi[8710]'));//'移除失败'
			}
		},

		handleSelectionChange(val) {
			let that = this;
			that.selectIDData = '';
			for (let i = 0; i < val.length; i++) {
				that.selectIDData += val[i].Exclusively_Id + ',';
			}
			console.log(that.selectIDData);
		},
		//工艺工时更新字段下拉框
		getDropList() {
			let that = this;
			that.$http.urlpost('Eng/Routings/RWHoursDropList', {}, res => {
				console.log(res);
				if (res.Success == 1) {
					that.drolist = res.DataContent;
					that.total1 = res.DataContent.length;
				}
			});
		},
		//流转下拉
		getDropLists() {
			let that = this;
			that.$http.urlpost('Eng/Routings/RoutMoveDropList', {}, res => {
				console.log(res);
				if (res.Success == 1) {
					that.drolistliu = res.DataContent;
				}
			});
		},

		handleChange(file, fileList) {
			let that = this;
			that.loading = true;
			console.log(file);
			if (file.response) {
				let response = file.response.Success;
				if (response == 0) {
					that.$message.error(file.response.Msg);
				} else {
					if(file.response.DataContent.dt.length>0){
					that.datajson = file.response.DataContent.dt;
                    that.returnArray = file.response.DataContent.TbHeader;
                    that.excelURL = file.response.DataContent.URL;
				}else{
					that.$message.warning(that.$t('getapi[8711]'));//Excel中无数据！
				}
				}
				that.loading = false;
			}
		},
		handleSuccess(res, file, fileList) {
			let that = this;
			console.log(res);
			let response = res.Success;
			if (response == 0) {
				that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
			} else {
				if(res.DataContent.dt.length>0){
                     that.datajson = res.DataContent.dt;
                     for(let i=0;i<that.datajson.length;i++){
							that.datajson[i].汇报时间 = that.$limits.getDateType(that.datajson[i].汇报时间);
						}
                     that.returnArray = res.DataContent.TbHeader;
                     that.excelURL = res.DataContent.URL;
				}else{
					that.$message.warning(that.$t('getapi[8711]'));//Excel中无数据！
				}
				
			}
			that.fileList=[];
		},
		handleError(err, file, fileList) {
			let that = this;
			that.$message.error(that.$t('getapi[8585]')+':' + err);//上传失败
		},
		handleChangeremark(file, fileList) {
			let that = this;
			console.log(file);
			if (file.response) {
				let response = file.response.Success;
				if (response == 0) {
					that.$message.error(file.response.Msg);
				} else {
					that.datajsonremark = file.response.DataContent;
				}
			}
		},
		handleSuccessremark(res, file, fileList) {
			let that = this;
			console.log(res);
			let response = res.Success;
			if (response == 0) {
				that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
			} else {
				that.datajsonremark = res.DataContent;
			}
		},
		handleErrorremark(err, file, fileList) {
			let that = this;
			that.$message.error(that.$t('getapi[8585]')+':' + err);//上传失败
		},
		handleChangeliu(file, fileList) {
			let that = this;
			console.log(file);
			if (file.response) {
				let response = file.response.Success;
				if (response == 0) {
					that.$message.error(file.response.Msg);
				} else {
					that.datajsonliu = file.response.DataContent;
				}
			}
		},
		handleSuccessliu(res, file, fileList) {
			let that = this;
			console.log(res);
			let response = res.Success;
			if (response == 0) {
				that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
			} else {
				that.datajsonliu = res.DataContent;
			}
			that.fileList=[];
			
		},
		handleRemove(file, fileList) {
			console.log(file, fileList);
		},
		handlePreview(file) {
			console.log("handlePreview"+file);
		},
		// 保存数据
		okbtn() {
			let that = this;
			that.loading = true;
			let parm = {
				SaveType: that.drosele,
                LangType: that.$processdata.getLang(),
				List: []
			};
			parm.List = that.datajson;
			console.log(JSON.stringify(parm));
			that.$http.urlpost('Eng/Routings/RWHoursSave', parm, function(res) {
				if (res.Success == 1) {
					that.$message.success(that.$t('getapi[818]'));
				}
				that.loading = false;
			});
		},
		// 保存备注数据
		okbtns() {
			let that = this;
			that.loading = true;
			let parm = that.datajsonremark;
			console.log(JSON.stringify(parm));
			that.$http.urlpost('Eng/Routings/RoutRemarkSave', parm, function(res) {
				if (res.Success == 1) {
					that.$message.success(that.$t('getapi[818]'));
				}
				that.loading = false;
			});
		},
		// 保存流转方向数据
		okbtnliu() {
			let that = this;
			if(that.droseleliu==4){
				that.loading = true;
				let parm = that.datajsonliu;
				console.log(JSON.stringify(parm));
				that.$http.urlpost('Eng/Routings/RoutRemarkSave', parm, function(res) {
				if (res.Success == 1) {
				that.$message.success(that.$t('getapi[818]'));
				}
				that.loading = false;
				});
			}else if(that.droseleliu==3){
				that.loading = true;
				let parm = {
				SaveType: that.droseleliu,
				List: []
				};
				parm.List = that.datajsonliu;
				console.log(JSON.stringify(parm));
				that.$http.urlpost('Eng/Routings/RoutMoveSave', parm, function(res) {
				if (res.Success == 1) {
				that.$message.success(that.$t('getapi[818]'));
				}
				that.loading = false;
				});
			}else{

				that.$message.warning(that.$t('getapi[8625]'));//'请选择更新字段'
			}
		}
	}
};
</script>

<style lang="scss" scoped>
span.label-fade-enter {
	font-size: medium;
	margin-right: 20px;
}
</style>
<style>
  .el-message-box {
    width: 600px;
  }
</style>
